export const SELECT_ARTICLE = 'selectArticle';
export const TRY_FETCH = 'tryFetchArticle';
export const FETCH_ARTICLE = 'fetchArticle';
export const FETCH_FEATURED_ARTICLES = 'fetchFeaturedArticles';
export const FETCH_ARTICLES_BY_CATEGORY = 'fetchArticlesByCategory';
export const FETCH_RELATED_ARTICLES = 'fetchRelatedArticles';
export const TOGGLE_CATEGORY_NAV = 'toggleCategoryNav';
